import { integrationConfig } from "./config";

export const getUrlencoded = (objs = {}) => {
    const urlencoded = new URLSearchParams();
    if(!objs["debug"]){
       
        urlencoded.append("debug", "");
    }
    
    if(!objs["debugEmail"]){
       
        urlencoded.append("debugEmail", "");
    }
    
   
    if(!objs["lead_source"]){
        urlencoded.append("lead_source", "Website");
    }
    
    if(!objs["company"]){
        urlencoded.append("company", "WebAds");
    }
    
    for (let ob in objs) {
        urlencoded.append(ob, objs[ob]);
    }
    return urlencoded;
}

export const callApi = (urlencoded,environment="development") => {
    const {endPoint,orgId} = integrationConfig[environment];
    urlencoded.append("oid", orgId);
    urlencoded.append("orgId", orgId);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    const requestOptions = {
        method: "POST",
        mode: 'no-cors',
        headers: myHeaders,
        body: urlencoded
    };
    return fetch(endPoint, requestOptions);
}

export const roles = [
    "Media Agency",
    "Brand Marketer",
    "Shopper Marketer",
    "Other"
];
export const leadSources = [
    "Advertisement",
    "Customer Event",
    "Employee Referral",
    "External Referral",
    "Google AdWords",
    "Partner",
    "Purchased List",
    "Trade Show",
    "Webinar",
    "Website",
    "Web Form"
];